// BigDawg Coaching — Form Handler
// Asset file: bigdawg-forms.js
// Handles: client onboarding form submission → custom success screen

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('onboardingForm');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var btn = form.querySelector('.submit-btn');
    if (btn) {
      btn.textContent = 'Submitting...';
      btn.disabled = true;
    }

    var data = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json' }
    })
    .then(function (res) {
      if (res.ok) {
        form.style.display = 'none';
        var success = document.getElementById('successScreen');
        if (success) {
          success.style.display = 'flex';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else {
        if (btn) { btn.textContent = 'Submit Onboarding Form'; btn.disabled = false; }
        alert('Something went wrong. Please try again or DM @theshapemt directly.');
      }
    })
    .catch(function () {
      if (btn) { btn.textContent = 'Submit Onboarding Form'; btn.disabled = false; }
      alert('Submission failed. Check your connection and try again.');
    });
  });
});